import React, { useState, useEffect } from 'react';
import Modal from 'components/shared/Modal/Modal';
import { LOADING_CIRCLE } from 'common/utils/constants';
import { getChangeLogs } from 'apis/GetServiceChangeLogs';
import ScrollReactTable from 'components/shared/ScrollReactTable/ScrollReactTable';

import './IbmsVersionModal.css';
import { appConfig } from 'config';
const semver = require('semver');

const IBMS_SERVICES_PAIR = [
  ['Auth Service', 'auth-service'],
  ['Bundle Manager Service', 'bundle-manager'],
  ['CM Service', 'cm-service'],
  ['Commissioning Service', 'commissioning-service'],
  ['Device Group Service', 'device-groups'],
  ['Device Log Service', 'device-log-service'],
  ['Device Stream Service', 'device-stream'],
  ['FM service', 'fm'],
  ['IBMS GUI', 'Unknown'],
  ['Inventory Service', 'inv-service'],
  ['PM Service', 'pm-service'],
  ['Real Time Service', 'real-time-service'],
  ['SW Manager Service', 'swmanager'],
  ['User Preference Service', 'user-preference'],
  ['Synthetic Alert Service', 'synth-alerts']
];

const COLUMNS_INDEXES = {
  0: 'Component',
  1: 'Version',
  2: 'Date Released'
};

const IbmsVersionModal = (props) => {
  const [latestVersions, setLatestVersions] = useState(Array(IBMS_SERVICES_PAIR.length).fill(''));
  const [latestVersionDates, setLatestVersionDates] = useState(Array(IBMS_SERVICES_PAIR.length).fill(''));
  const [requestReturnedCount, setRequestReturnedCount] = useState(0);

  // send requests
  useEffect(() => {
    IBMS_SERVICES_PAIR.forEach(async (servicePair, index) => {
      // fetch local UI changelog
      if (servicePair[0] === 'IBMS GUI') {
        const baseUrl = appConfig.webBaseUrl;
        fetch(`${baseUrl}/info?format=json`)
          .then((res) => res.json())
          .then((changelogJson) => {
            let latestVersionObj = getLatestVersion(changelogJson, index);
            // temp: directly fix to V1
            // latestVersionObj.version = '0.1.62-5';
            // latestVersionObj.date = '2022-11-03';

            setLatestVersions((latestVersions) => [
              ...latestVersions.slice(0, index),
              latestVersionObj.version,
              ...latestVersions.slice(index + 1)
            ]);
            setLatestVersionDates((latestVersionDates) => [
              ...latestVersionDates.slice(0, index),
              latestVersionObj.date,
              ...latestVersionDates.slice(index + 1)
            ]);
            setRequestReturnedCount((requestReturnedCount) => requestReturnedCount + 1);
          })
          .catch((e) => {
            console.log(e);
            setLatestVersions((latestVersions) => [
              ...latestVersions.slice(0, index),
              'Not Available',
              ...latestVersions.slice(index + 1)
            ]);
            setLatestVersionDates((latestVersionDates) => [
              ...latestVersionDates.slice(0, index),
              'Not Available',
              ...latestVersionDates.slice(index + 1)
            ]);
            setRequestReturnedCount((requestReturnedCount) => requestReturnedCount + 1);
          });

        return;
      }

      if (servicePair[0] === 'Inventory Service') {
        const isStagingEnv = appConfig.webBaseUrl === 'https://ibms-ui-staging.azurewebsites.net';
        const isVerizon1Env = appConfig.webBaseUrl === 'https://ibms-ui-verizon1.azurewebsites.net';
        if (isStagingEnv) {
          handleGetChangeLogs(servicePair[1], index, 'dev');
          return;
        } else if (isVerizon1Env) {
          handleGetChangeLogs(servicePair[1], index, 'prod');
          return;
        }
      }

      handleGetChangeLogs(servicePair[1], index);
    });
  }, []);

  // fetch service changelogs
  const handleGetChangeLogs = (service, index, env = null) => {
    // env can be 'dev', 'staging', 'verizon1', or 'prod'
    getChangeLogs(service, 'json', env)
      .then((res) => {
        const latestVersionObj = getLatestVersion(res, index);
        setLatestVersions((latestVersions) => [
          ...latestVersions.slice(0, index),
          latestVersionObj.version,
          ...latestVersions.slice(index + 1)
        ]);
        setLatestVersionDates((latestVersionDates) => [
          ...latestVersionDates.slice(0, index),
          latestVersionObj.date,
          ...latestVersionDates.slice(index + 1)
        ]);
        setRequestReturnedCount((requestReturnedCount) => requestReturnedCount + 1);
      })
      .catch((error) => {
        setLatestVersions((latestVersions) => [
          ...latestVersions.slice(0, index),
          'Not Available',
          ...latestVersions.slice(index + 1)
        ]);
        setLatestVersionDates((latestVersionDates) => [
          ...latestVersionDates.slice(0, index),
          'Not Available',
          ...latestVersionDates.slice(index + 1)
        ]);
        setRequestReturnedCount((requestReturnedCount) => requestReturnedCount + 1);
      });
  };

  const getLatestVersion = (response, index = 0) => {
    if (!response?.versions) return { version: 'Not Available', date: 'Not Available' };

    let latestVersion;
    let latestVersionDate;

    const allVersions = Object.keys(response.versions);
    allVersions.forEach((versionKey) => {
      const versionObj = response.versions[versionKey];

      if (!semver.valid(versionObj.version)) return;
      if (!latestVersion) {
        latestVersion = versionObj.version;
        latestVersionDate = versionObj.date;
        return;
      }
      if (semver.gt(versionObj.version, latestVersion)) {
        latestVersion = versionObj.version;
        latestVersionDate = versionObj.date;
      }
    });

    return { version: latestVersion || 'Not Available', date: latestVersionDate || 'Not Available' };
  };
  const getColumns = () => [0, 1, 2].map((colIndex) => getSingleColumn(colIndex));

  const getTableData = (colIndex, versionIndex) => {
    switch (colIndex) {
      case 0:
        return <div className="IbmsVersionModal_SingleService_Title">{IBMS_SERVICES_PAIR[versionIndex][0]}</div>;
      case 1:
        return <div className="IbmsVersionModal_SingleService_VersionNumber">{latestVersions[versionIndex]}</div>;
      case 2:
        return <div className="IbmsVersionModal_SingleService_VersionDate">{latestVersionDates[versionIndex]}</div>;
      default:
        break;
    }
  };

  const getSingleColumn = (index) => ({
    Header: (col) => {
      return (
        <div className="IbmsVersionTable_OuterDiv">
          <span className="IbmsVersionTable_HeaderLabel">{COLUMNS_INDEXES[index]}</span>
          {index !== 2 && (
            <div className="ConfigHistoryTableHeader_ResizerSliderIcon">
              <div className="ConfigHistoryTableHeader_ResizerSliderIcon_Bar"></div>
            </div>
          )}
        </div>
      );
    },
    id: `ibms_version_${COLUMNS_INDEXES[index]}`,
    resizable: index !== 2,
    minWidth: 100,
    accessor: (versionIndex) => versionIndex,
    Cell: (row) => {
      return <div className="IbmsVersion_cellWrapper">{getTableData(index, row.value)}</div>;
    },
    fixed: 'left'
  });

  const isLoading = () => requestReturnedCount !== IBMS_SERVICES_PAIR.length;

  return (
    <Modal animateX={false} close={props.onClose} noPadding height={750} width={935}>
      <div className="IbmsVersionModal_Header">
        <div className="IbmsVersionModal_Header_Title">About IBMS components</div>
        <div className="IbmsVersionModal_Header_Version">{`IBMS Version ${props.ibmsUnifiedVersion}`}</div>
      </div>
      {isLoading() && <div>{LOADING_CIRCLE}</div>}
      {!isLoading() && (
        <div className="IbmsVersionModalContainer">
          <ScrollReactTable
            key={1}
            showPagination={false}
            resizable={true}
            sortable={false}
            noDataText={''}
            fetching={false}
            className={'-highlight ibmsVersionTable Global_Table'}
            defaultPageSize={0}
            pageSize={IBMS_SERVICES_PAIR.length}
            minRows={14}
            getTdProps={(state, rowInfo, column, instance) => {
              return {
                onClick: (e, handleOriginal) => {
                  if (handleOriginal) {
                    handleOriginal(); /* Suggested by documentation, makes sure that default click functions still get called if necessary*/
                  }
                }
              };
            }}
            data={IBMS_SERVICES_PAIR.map((service, index) => index)}
            columns={[...getColumns()]}
            withFixedColumns={true}
          />
        </div>
      )}
    </Modal>
  );
};

export default IbmsVersionModal;
